var map = {
	"./0.0_Overview.jpg": "993c",
	"./2.0_planning.jpg": "ce09",
	"./2.1_planning.jpg": "5e37",
	"./exploration/1-0-office-clearing-bg.png": "19ab",
	"./exploration/1-A-Clearing-bg.png": "89c2",
	"./exploration/1-A-Clearing_1.png": "5326",
	"./exploration/1-B-exploration-drilling-bg.png": "fd01",
	"./exploration/1-B-exploration-drilling.png": "992a",
	"./exploration/1-C-resources-bg.png": "ce8e",
	"./exploration/1-C-resources.png": "8138",
	"./exploration/1-D-characterisation.png": "120e",
	"./exploration/1-D-characterisation_1.png": "4595",
	"./hexagon-logo.png": "b39b",
	"./hexagon-logo.svg": "fc5e",
	"./journey1-0.png": "adcf",
	"./journey1-A.png": "58d6",
	"./journey1-B.png": "b821",
	"./journey1-C.png": "5cb8",
	"./journey1-D.png": "767f",
	"./map-icon.png": "843e",
	"./vid-placeholder.png": "ca35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";